export default __webpack_public_path__ + "static/media/808.53e18758.png";